import { useQuery } from '@apollo/client/react';

import { useQueryErrorToast } from './useQueryErrorToast';
import { LIST_STAFF_TRACKING_QUERY } from '../libs/graphQL';

export interface StaffTrackingMediaUrl {
  cam: string;
  url: string;
}

export interface StaffTrackingStationValue {
  station: string;
  value: number;
}

export interface StaffTrackingMeal {
  mealId: string;
  name?: string | null;
  size?: string | null;
  startWall: string;
  endWall: string;
  intervalsDone: number;
  latestAvgWorkers: number;
  totalWorkTimeSec: number;
  mealsProcessed?: number | null;
  totalMealsToProcess?: number | null;
}

export interface StaffTrackingPerStationMeals {
  station: string;
  meals: StaffTrackingMeal[];
}

export interface StaffTrackingInterval {
  intervalsDone: number;
  intervalSec: number;
  latestAvgWorkersPerStation: StaffTrackingStationValue[];
  totalWorkTimeSecPerStation: StaffTrackingStationValue[];
  perStationMeals?: StaffTrackingPerStationMeals[];
}

export interface StaffTrackingRecord {
  id: string;
  kitchen: string;
  day: string;
  shift: string;
  coveredStations: string[];
  imageUrls: StaffTrackingMediaUrl[];
  videoUrls: StaffTrackingMediaUrl[];
  intervals: StaffTrackingInterval[];
}

interface UseStaffTrackingQueryParams {
  kitchen: string;
  startDate: string;
  endDate: string;
  shift?: string;
}

const EMPTY_STAFF_TRACKING_RECORDS: StaffTrackingRecord[] = [];

const useStaffTrackingQuery = ({ kitchen, startDate, endDate, shift }: UseStaffTrackingQueryParams) => {
  const { data, loading, error, refetch } = useQuery<{ listStaffTracking: { data: StaffTrackingRecord[] } }>(
    LIST_STAFF_TRACKING_QUERY,
    {
      variables: { kitchen, startDate, endDate, shift: shift || undefined },
      fetchPolicy: 'network-only'
    }
  );

  useQueryErrorToast(error);

  return {
    staffTrackingRecords: data?.listStaffTracking?.data ?? EMPTY_STAFF_TRACKING_RECORDS,
    staffTrackingLoading: loading,
    staffTrackingError: error,
    refetchStaffTracking: refetch
  };
};

export default useStaffTrackingQuery;
